import { createEffect } from "effector";
import { Customer, EditCustomer, NewCustomer } from "../../types/customers.types";
import { addCustomer, deleteCustomer, editCustomer, getCustomers } from "../../services/customerService";
import { getWashingTypes } from "../../services/washingTypesService";
import { AppError } from "../../services/classes";

export const getWashingTypesEffect = createEffect(async () => {
  const { response } = await getWashingTypes();

  return response;
});

export const getCustomersEffect = createEffect<void, Customer[], AppError>(
  async () => {
    return await getCustomers();
  }
);

export const addCustomerEffect = createEffect<NewCustomer, Customer, AppError>(async (customer: NewCustomer) => {
  const response = await addCustomer(customer);

  return response;
});

export const editCustomerEffect = createEffect<EditCustomer, Customer, AppError>(async (customer: EditCustomer) => {
  const response = await editCustomer(customer);

  return response;
});

export const deleteCustomerEffect = createEffect<string, string, AppError>(async (customerId: string) => {
  await deleteCustomer(customerId);

  return customerId;
});
